import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Fragment, useCallback } from 'react';
import { createConvertJacksToChipsOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { PanelItem } from '../../panels/panelItem';
import { thunkCloseCurrentMessageBox } from '../../redux/actions/messageBoxesActions';
import { selectMyNumJacks } from '../../redux/reducers/selfDataReducer';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { OpenModalContainer } from '../openModalContainer';
import { ValueDisplay } from '../valueDisplay';
import { GoToAccountModalHeaderButton } from './goToAccountModalHeaderButton';
const GRID_CSS = css `
  display: inline-grid;
  grid-template-columns: auto auto;
  gap: 10px;
  align-items: center;
`;
export const JacksToChipsModal = ({ jacksToChipsOptions, onClose }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const myNumJacks = useAppSelector(selectMyNumJacks);
    const onClickConvert = useCallback((jacksToChipsOption) => {
        socketSend(createConvertJacksToChipsOutbound(jacksToChipsOption));
        dispatch(thunkCloseCurrentMessageBox());
    }, [dispatch, socketSend]);
    return (_jsx(OpenModalContainer, { title: 'Convert Jacks to Chips', onClose: onClose, maxWidth: 'md', additionalControls: _jsx(GoToAccountModalHeaderButton, { onClose: onClose }), children: _jsxs(DialogContent, { children: [_jsx(Typography, { component: 'div', children: _jsx("div", { css: GRID_CSS, children: jacksToChipsOptions.map((jacksToChipsOption, i) => {
                            const label = `Get ${jacksToChipsOption.numChips.toLocaleString()} Chips`;
                            const isDisabled = myNumJacks !== undefined && myNumJacks < jacksToChipsOption.numJacks;
                            return (_jsxs(Fragment, { children: [_jsx(Button, { onClick: () => onClickConvert(jacksToChipsOption), variant: 'contained', size: 'large', disabled: isDisabled, children: label }), _jsxs("span", { children: [_jsx("span", { css: css `
                        opacity: 0.5;
                      `, children: "for" }), ' ', _jsx(ValueDisplay, { label: 'Jacks', type: 'jacks', value: jacksToChipsOption.numJacks, isLabelFirst: false })] })] }, i));
                        }) }) }), myNumJacks !== undefined && (_jsx(PanelItem, { children: _jsx(ValueDisplay, { label: 'Your Jacks', type: 'jacks', value: myNumJacks, isLabelFirst: true }) }))] }) }));
};
